export const FAQ_ITEMS: FAQItem[] = [
  {
    id: "is-bank",
    question: "Is Repayas a bank?",
    answer:
      "No. Repayas is not a bank, does not hold your money, and is not regulated by the FCA. We connect to your existing bank account through Open Banking to read your transaction data and calculate your Safe-to-Spend figure.",
  },
  {
    id: "vat-filing",
    question: "Does Repayas file my VAT return?",
    answer:
      "No. Repayas does not file VAT returns or provide tax advice. We show you an estimate of your VAT liability based on your transactions, but you should always confirm with your accountant and use MTD-compliant software for filing.",
  },
  {
    id: "open-banking-safe",
    question: "Is Open Banking safe?",
    answer:
      "Yes. Open Banking is regulated by the FCA and uses bank-level security. Repayas connects through TrueLayer, an FCA-authorised provider. We never see or store your bank login credentials.",
  },
  {
    id: "low-confidence",
    question: "What happens if confidence is low?",
    answer:
      "If your Safe-to-Spend figure has low confidence, we tell you clearly. This usually means your bank connection is stale or we could not categorise some transactions. You can refresh your connection or provide more information to improve accuracy.",
  },
  {
    id: "built-for",
    question: "Who is Repayas built for?",
    answer:
      "Repayas is built for VAT-registered UK small businesses who want clarity over their cash flow. This includes sole traders, limited companies, and partnerships who need to know what is safe to spend after accounting for VAT.",
  },
];
